import React, { FC } from 'react';
import { Outlet, ScrollRestoration } from 'react-router-dom';

import { ErrorBoundary } from 'src/components/error-boundary';
import { Footer } from 'src/components/footer';
import { Header } from 'src/components/header';
import { config } from 'src/config';
import { useNavPromptWhileOrdering } from 'src/state/order/hooks';

import { StyledApp, StyledAppContent } from './app.styled';

const ENVIRONMENT = config.ENV;

const ThrowIfNoConfig = () => {
  if (!ENVIRONMENT) {
    throw new Error('Configuration failed to load');
  }

  return null;
};

export const App: FC = () => {
  useNavPromptWhileOrdering();

  return (
    <StyledApp>
      <Header />
      <ScrollRestoration />
      <StyledAppContent id="content" aria-live="polite">
        <ErrorBoundary>
          <ThrowIfNoConfig />
          <Outlet />
        </ErrorBoundary>
      </StyledAppContent>
      <Footer />
    </StyledApp>
  );
};
